import { post } from '@/utils/request'

// 获取订单列表
export function getOrderList(data) {
    return post('/admin/edu_youth_order/orderList', data)
}

// 获取订单详情
export function getOrderDetail(data) {
    return post('/admin/edu_youth_order/orderDetail', data)
}

// 订单发货
export function orderDeliver(data) {
    return post('/admin/edu_youth_order/orderDeliver', data)
}

// 取消订单
export function cancelOrder(data) {
    return post('/admin/edu_youth_order/cancelOrder', data)
}

// 删除订单
export function deleteOrder(data) {
    return post('/admin/edu_youth_order/deleteOrder', data)
}

// 确认收货
export function confirmReceive(data) {
    return post('/admin/edu_youth_order/confirmReceive', data)
}
